import React from "react";
import CernerSVG from "src/icons/collections/integrations/CernerSVG.svg";

const CernerIcon = () => (<img src={CernerSVG} alt =''/>);

export default CernerIcon;
